import { handleErrorWithSentry } from '@sentry/sveltekit';
import * as Sentry from '@sentry/sveltekit';
import { baseSentryConfig } from '#lib/infrastructure/sentry/index.ts';
import { gameState } from '#lib/root.ts';

export const initSentryClient = () => {
	Sentry.init({
		...baseSentryConfig,
		// This sets the sample rate to be 10%. You may want this to be 100% while
		// in development and sample at a lower rate in production
		replaysSessionSampleRate: 0.1,

		// If the entire session is not sampled, use the below sample rate to sample
		// sessions when an error occurs.
		replaysOnErrorSampleRate: 1.0,

		// If you don't want to use Session Replay, just remove the line below:
		integrations: [
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false
			}),
			Sentry.feedbackIntegration({
				colorScheme: 'dark',
				showEmail: false,
				showName: false,
				onFormOpen: () => {
					// eslint-disable-next-line no-console
					console.log(gameState.toDTO(), null, 2);
				}
			})
		]
	});

	// If you have a custom error handler, pass it to `handleErrorWithSentry`
	return { handleError: handleErrorWithSentry() };
};
